import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

// 28-09
import {
  FaMapMarkerAlt,
  FaRegCalendarAlt,
  FaRegClock,
  FaMountain,
  FaBullseye,
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { TbLocation } from "react-icons/tb";

const STATUS_STYLES = {
  pending: {
    label: "Pending",
    color: "#F59E0B",
    textColor: "#E8890C",
    bg: "#FFFFFF",
    img: "/Pending icon 32 Size.png",
  },
  sendback: {
    label: "Send Back",
    color: "#0D6EFD",
    textColor: "#0D6EFD",
    bg: "#FFFFFF",
    img: "/send back 32 size.png",
  },
  approved: {
    label: "Approved",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
  rejected: {
    label: "Rejected",
    color: "#FF5C6C",
    textColor: "#FF5C6C",
    bg: "#FFFFFF",
    img: "/Reject 32 size.png",
  },
};
 
const StatusBadge = ({ status }) => {
  const key = (status || "").replace(/\s+/g, "").toLowerCase();
 
  const s = STATUS_STYLES[key] || STATUS_STYLES.pending;
 
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minWidth: "95px",
        padding: "5px 12px",
        border: `1px solid ${s.color}`,
        borderRadius: "20px",
        color: s.textColor,
        backgroundColor: s.bg,
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={s.img}
        alt={s.label}
        style={{ width: "18px", height: "18px", objectFit: "contain" }}
      />
      {s.label}
    </span>
  );
};
 

const ProgressReportOutwardList = () => {


 // 28-09
const [currentSlide, setCurrentSlide] = useState(0);
  const CARD_THEMES = [
  { border: "#3b82f6", bg: "#f3f8ff", iconBg: "#dbeafe", icon: "#3b82f6" }, // blue
  { border: "#8b5cf6", bg: "#f6f4ff", iconBg: "#e9e4ff", icon: "#8b5cf6" }, // purple
  { border: "#22a55a", bg: "#f2fbf5", iconBg: "#d5f3e0", icon: "#22a55a" }, // green
  { border: "#f59e0b", bg: "#fffaf0", iconBg: "#fdebc8", icon: "#f59e0b" }, // orange
];

const InfoRow = ({ icon, label, value, theme }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "7px",
      fontSize: "11px",
    }}
  >
    <span
      style={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: theme.iconBg,
        color: theme.icon,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        flexShrink: 0,
      }}
    >
      {icon}
    </span>
    <span>
      <b>{label}:</b> {value}
    </span>
  </div>
);

  const context = useContext(AdminContext);
  // NOTE: rename this to whatever your Application context actually
  // exposes for the outward/processed list.
  const { GetProgressReportOutwardList, GetBudgetHeadInfo } = context;
  const t = (text) => text;
  const nav = useNavigate();
  const loginData = JSON.parse(sessionStorage.getItem("UserData"));
  const isMaker = loginData?.Department_Name === "State Maker";
  const isChecker = loginData?.Department_Name === "State Checker";
  // ----- data / list state -----
  const [progressReports, setProgressReports] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
   const [statusFilter, setStatusFilter] = useState("All");
  // ----- pagination -----
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  // ----- photo viewer -----
  const [showSpecific, setShowSpecific] = useState(0);
  const [selectedUploadId, setSelectedUploadID] = useState();
  const [FetchedImages, setFetchedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const totalPages = Math.max(
    1,
    Math.ceil((filteredBills?.length || 0) / billsPerPage),
  );
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  // ==============================
  // Fetch outward list (Approved records only — per backend)
  // ==============================
  const getOutwardList = async () => {
    setLoading(true);
    try {
      const result = await GetProgressReportOutwardList();
      const rows = Array.isArray(result) ? result : result?.Data || [];
      console.log("Outward rows:", rows);
      setProgressReports(rows);
      setFilteredBills(rows);
    } catch (error) {
      console.log("GetProgressReportOutwardList Error :", error);
      setProgressReports([]);
      setFilteredBills([]);
      alert("Unable to load Progress Report Outward List.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOutwardList();
  }, []);

  // ==============================
  // Search filter
  // ==============================
  // useEffect(() => {
  //   const lowerSearchTerm = searchTerm.toLowerCase();
  //   const filtered = progressReports.filter((row) =>
  //     Object.values(row).some((val) =>
  //       (val || "").toString().toLowerCase().includes(lowerSearchTerm),
  //     ),
  //   );

  //   setFilteredBills(filtered);
  //   setCurrentPage(1);
  // }, [searchTerm, progressReports]);

   useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = progressReports.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesStatus =
            statusFilter === "All" ||
            (bill.Status || "").toLowerCase() === statusFilter.toLowerCase();
 
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, progressReports]);
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [filteredBills, totalPages, currentPage]);

  // ==============================
  // Photo viewer
  // ==============================
  const fetchSpecficUploadPhoto = async (
    uploadID,
    WorkOrderNo,
    physicalWork,
  ) => {
    try {
      const res = await GetBudgetHeadInfo(
        uploadID,
        "GetSpecificUploadImagesfromProgressTable",
      );
      const filteredImages = (res?.Data || []).filter(
        (img) => img.PhysicalProgress === physicalWork,
      );

      setFetchedImages(filteredImages);
      setSelectedUploadID(uploadID);
       setCurrentSlide(0); // <-- add this 28-09
      setShowSpecific(1);
    } catch (err) {
      console.log(err);
    }
  };

  const parseUploads = (upload) => {
    try {
      if (Array.isArray(upload)) return upload;
      return JSON.parse(upload || "[]");
    } catch {
      return [];
    }
  };

  const parseLocations = (location) => {
    try {
      if (Array.isArray(location)) {
        return location.map((loc) =>
          typeof loc === "string" ? JSON.parse(loc) : loc,
        );
      }
      const parsed = JSON.parse(location || "[]");
      return parsed.map((loc) =>
        typeof loc === "string" ? JSON.parse(loc) : loc,
      );
    } catch {
      return [];
    }
  };
  const navigatetoMap = (projectId) => {
    if (!projectId) return;
    nav(`/AdminDashboard/MapFunction/${projectId}`, {
      state: { from: "ProgressReport" },
    });
  };
  const renderStatus = (status) => {
    switch (status) {
      case "Approved":
        return (
          <span
            style={{
              color: "#198754",
              background: "#d1e7dd",
              padding: "4px 10px",
              borderRadius: "15px",
              fontWeight: "600",
              fontSize: "12px",
            }}
          >
            Approved
          </span>
        );

      case "Rejected":
        return (
          <span
            style={{
              color: "#dc3545",
              background: "#f8d7da",
              padding: "4px 10px",
              borderRadius: "15px",
              fontWeight: "600",
              fontSize: "12px",
            }}
          >
            Rejected
          </span>
        );

      case "Pending":
      default:
        return (
          <span
            style={{
              color: "#856404",
              background: "#fff3cd",
              padding: "4px 10px",
              borderRadius: "15px",
              fontWeight: "600",
              fontSize: "12px",
            }}
          >
            Pending
          </span>
        );
    }
  };

  const getPageNumbers = () => {
    const pages = [];

    // 5 ya usse kam pages
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, 5);
      pages.push("...");
      pages.push(totalPages);

      return pages;
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      pages.push("...");

      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    pages.push("...");

    pages.push(
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
    );

    pages.push("...");
    pages.push(totalPages);

    return pages;
  };

  return (
    <>
     <style>
        {/* 09-10  */}
        {`
    .progress-table {
  width: 100%;
  min-width: 1500px;
  background: #ffffff;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
}
 
.progress-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}
 
.progress-table-th {
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 11px 10px;
  // //28/10
  // background: #e5e9f8;
  color: white;
  border-right: 1px solid #d7dcef;
  border-bottom: 1px solid #d7dcef;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}
 
 
 
 
 
  .progress-table-td {
    padding: 10px;
    color: #222222;
    border-right: 1px solid #e5e7ef;
    border-bottom: 1px solid #e5e7ef;
    text-align: center;
    font-size: 13px;
    font-weight: 400;
    vertical-align: middle;
    white-space: nowrap;
    height: 40px;
  }
 
  .progress-table-th:last-child,
  .progress-table-td:last-child {
    border-right: none;
  }
 
 
`}
      </style>
      {showSpecific === 0 && (
        <div
          style={{
            background: "white",
            width: "100%",
            height: "83vh",
            transition: "margin-left 0.3s ease",
            overflowY: "visible",
            padding: "0 40px 30px",
            fontFamily: "Inter, sans-serif",
            boxSizing: "border-box",
          }}
        >
               {/* //29/10 */}
            <div
      style={{
        background: "#EEF2F7",
        border: "1px solid #dfe5ee",
        borderRadius: "10px",
        padding: "10px 20px 20px",
        boxSizing: "border-box",
        width: "100%",
      }}
    >
          {/* ---- Header Section ---- */}
          <div
              style={{
              display: "flex",
              justifyContent: "space-between",
              // gap:"50px",
              alignItems: "center",
              marginBottom: "10px",
              padding: "0 20px",
              width: "100%",
              marginTop: "25px",
            }}
          >
            <h5
              style={{
                fontWeight: "bold",
                color: "black",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={"/List-32.png"}
                alt="Project Icon"
                style={{ marginRight: "10px", width: 28, height: 28 }}
              />
              Progress Report Outward List
            </h5>

            {/* ---- Search Box ---- */}
            <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
            <div
              style={{
                 display: "flex",
                alignItems: "center",
                //29/10
                backgroundColor:"white",
                border: "1px solid #ccc",
                borderRadius: "5px",
                padding: "5px 10px",
                width: "250px"
              }}
            >
              <img
                src={"/Search-32.png"}
                alt="Search Icon"
                style={{ width: 20, height: 20, marginRight: "8px" }}
              />
              <input
                type="text"
                placeholder="Search Report..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  width: "100%",
                  fontSize: "14px",
                }}
              /></div>
                <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
    style={{
        width: "140px",
        height: "36px",
        marginLeft: "10px",
        border: "1px solid #d5dce5",
        borderRadius: "8px",
        padding: "0 10px",
        fontSize: "12px",
        outline: "none",
        background: "#fff",
        cursor: "pointer"
    }}
>
    <option value="All">All Status</option>
    <option value="Pending">Pending</option>
    <option value="SendBack">SendBack</option>
    <option value="Approved">Approved</option>
    <option value="Rejected">Rejected</option>
</select>
            </div>
          
          </div>
          <div
 // 23-10
                style={{
    display: "block",
    width: "100%",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    backgroundColor: "white",
    padding: "15px 20px",
    boxSizing: "border-box",
    overflow: "visible",
  }}
          >
            {loading && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(255,255,255,0.7)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    border: "6px solid #f3f3f3",
                    borderTop: "6px solid #007bff",
                    borderRadius: "50%",
                    width: "60px",
                    height: "60px",
                    animation: "spin 1s linear infinite",
                  }}
                />
                <style>{`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}</style>
              </div>
            )}

            {/* ---- Table Section ---- */}
            {/* <div
              style={{ overflowX: "auto", width: "100%", overflowY: "hidden" }}
            > */}
            <div
 // 23-10
 style={{
    width: "100%",
    overflowX: "auto",
    overflowY: "auto",
    border: "1px solid #dde2f0",
    borderRadius: "10px",
    position: "relative",
    display: "block",
  }}
>
              <table className="progress-table">
                <thead>
                  <tr
                    style={{
                       //28/10
                      backgroundColor: "#2D79D9",
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "400",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <th className="progress-table-th">Sr No</th>
                    <th className="progress-table-th">Financial Year</th>
                    <th className="progress-table-th">ProjectID</th>
                    <th className="progress-table-th">Project Name</th>
                    <th className="progress-table-th">Scheme</th>
                    <th className="progress-table-th">Work Name</th>
                    <th className="progress-table-th"  style={{ width: "350px" }} >Location</th>
                    <th className="progress-table-th">Physical Progress(%)</th>
                    <th className="progress-table-th">Description</th>
                    <th className="progress-table-th">Status</th>

                    <th className="progress-table-th">Remark</th>

                    <th className="progress-table-th">Rejected By</th>

                    {/* <th className="progress-table-th">View Photos</th> */}
                    <th className="progress-table-th">View MAP</th>
                  </tr>
                </thead>

                {currentBills?.length > 0 ? (
                  currentBills.map((row, index) => {
                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                    const uploadedFiles = parseUploads(row.Upload);

                    return (
                      <tbody key={row.ID ?? index}>
                        <tr
                          style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            backgroundColor: bgColor,
                          }}
                        >
                          <td className="progress-table-td">
                            {indexOfFirstBill + index + 1}
                          </td>
                           <td className="progress-table-td">
                            {row.FinancialYear}
                          </td>
                          <td className="progress-table-td" style={{color:"#5295c9"}}>{row.ProjectID}</td>
                         
                          <td className="progress-table-td"  style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}>
                            {row.ProjectName}
                          </td>
                          <td className="progress-table-td">{row.Scheme}</td>
                          <td className="progress-table-td"  style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}>{row.WorkName}</td>

                          {/* Same Start/End coordinate rendering as ProgressReportInward */}
                          <td
                            style={{ minWidth: "260px", whiteSpace: "normal" }}
                          >
                            {row.StartCoordinates && row.EndCoordinates ? (
                              <>
                                <div>
                                  <strong>Start :</strong>{" "}
                                  {JSON.parse(row.StartCoordinates).join(", ")}
                                </div>
                                <div>
                                  <strong>End :</strong>{" "}
                                  {JSON.parse(row.EndCoordinates).join(", ")}
                                </div>
                              </>
                            ) : (
                              "Area Not Selected"
                            )}
                          </td>

                          <td className="progress-table-td">
                            {/* {row.PhysicalProgress} */}
                            <button
                                className="btn btn-success px-3"
                                onClick={() =>
                                  fetchSpecficUploadPhoto(
                                    row.UploadID,
                                    row.WorkOrderNo,
                                    row.PhysicalProgress,
                                  )
                                }
                                style={{
                                  fontSize: "12px",
                                  background:
                                    "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                  color: "white",
                                  border: "none",
                                  padding: "6px 12px",
                                  borderRadius: "8px",
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "4px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {t("View Photos")}
                              </button>
                          </td>
                          <td className="progress-table-td"  style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}>
                            {row.Description}
                          </td>
                          {/* <td style={{ padding: "10px", textAlign: "center" }}>
                            {" "}
                            {renderStatus(row.Status)}
                          </td> */}
                          <td style={{ padding: "10px" }}>
  <StatusBadge status={row.Status} />
</td>
                          <td className="progress-table-td">
                            {row.Remark || "--"}
                          </td>
                          <td className="progress-table-td">
                            {row.RejectedBy || "--"}
                          </td>
                          {/* <td style={{ padding: "10px", textAlign: "center" }}>
                            <button
                              className="btn btn-success px-3"
                              onClick={() =>
                                fetchSpecficUploadPhoto(
                                  row.UploadID,
                                  row.WorkOrderNo,
                                  row.PhysicalProgress,
                                )
                              }
                              style={{
                                fontSize: "12px",
                                background:
                                  "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                color: "white",
                                border: "none",
                                padding: "6px 12px",
                                borderRadius: "8px",
                                display: "inline-flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "4px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {t("View Photos")}
                            </button>
                          </td> */}

                          <td style={{ padding: "10px" }}>
                            <button
                              onClick={() => navigatetoMap(row.ProjectID)}
                              style={{
                                cursor: "pointer",
                                background:
                                  "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                color: "white",
                                border: "none",
                                padding: "6px 10px",
                                borderRadius: "8px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Go to Map
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })
                ) : (
                  <tbody>
                    <tr>
                       {/* 23-10 */}
                      {/* <td
        colSpan={13}
        style={{
          textAlign: "center",
          padding: "30px 15px",
          backgroundColor: "#ffffff",
          color: "#555",
          fontSize: "14px",
        }}
      >
        No data available
      </td> */}
                    </tr>
                  </tbody>
                )}
              </table>
                   {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                        <div
                            style={{
                                position: "sticky",
                                left: 0,
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "150px",
                                boxSizing: "border-box",
                                backgroundColor: "#ffffff",
                                color: "#333",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}
                        >
                            No data available
                        </div>
                    )}
            </div>

            {/* ---- Pagination ---- */}
            {/* ---- Pagination ---- */}

            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "0px",
                padding: "20px 5px",
                boxSizing: "border-box",
              }}
            >
              {/* ================= SHOWING ENTRIES ================= */}

              <div
                style={{
                  fontSize: "13px",
                  color: "#333",
                  whiteSpace: "nowrap",
                }}
              >
                Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
                to {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
                {filteredBills?.length || 0} entries
              </div>

              {/* ================= PAGINATION ================= */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "18px",
                }}
              >
                {/* Previous */}

                <button
                  type="button"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "#2ea4e7",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    fontSize: "13px",
                    padding: 0,
                    opacity: currentPage === 1 ? 0.5 : 1,
                  }}
                >
                  ‹ Previous
                </button>

                {/* Page Numbers */}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  {getPageNumbers().map((pageNumber, index) => {
                    // Dots
                    if (pageNumber === "...") {
                      return (
                        <span
                          key={`dots-${index}`}
                          style={{
                            color: "#444",
                            fontSize: "13px",
                          }}
                        >
                          ...
                        </span>
                      );
                    }

                    // Page Number
                    return (
                      <button
                        type="button"
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        style={{
                          border: "none",
                          background: "transparent",
                          padding: 0,
                          color:
                            currentPage === pageNumber ? "#2ea4e7" : "#444",
                          cursor: "pointer",
                          fontSize: "13px",
                          fontWeight:
                            currentPage === pageNumber ? "600" : "400",
                          textDecoration:
                            currentPage === pageNumber ? "underline" : "none",
                        }}
                      >
                        {pageNumber}
                      </button>
                    );
                  })}
                </div>

                {/* Next */}

                <button
                  type="button"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages || totalPages <= 1}
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "#2ea4e7",
                    cursor:
                      currentPage === totalPages || totalPages <= 1
                        ? "not-allowed"
                        : "pointer",
                    fontSize: "13px",
                    padding: 0,
                    opacity:
                      currentPage === totalPages || totalPages <= 1 ? 0.5 : 1,
                  }}
                >
                  Next ›
                </button>
              </div>
            </div>
          </div>
        </div></div>
      )}

      {/* ---- Photo Viewer ---- */}
     {showSpecific === 1 && (() => {
  const cards = [];
  (FetchedImages || []).forEach((val, index) => {
    const images = val.Upload
      ? val.Upload.split(",").map((img) => img.trim())
      : [];

    const locations = (() => {
      try {
        if (!val.Location) return [];
        if (
          typeof val.Location === "string" &&
          val.Location.includes(",") &&
          !val.Location.startsWith("[")
        ) {
          const [lat, lng] = val.Location.split(",");
          const dt = val.Date ? new Date(val.Date) : null;
          return [
            {
              latitude: lat?.trim(),
              longitude: lng?.trim(),
              date: dt ? dt.toLocaleDateString("en-GB") : "-",
              time: dt ? dt.toLocaleTimeString("en-GB", { hour12: false }) : "-",
              elevation: "",
              accuracy: "",
            },
          ];
        }
        return parseLocations(val.Location);
      } catch {
        return [];
      }
    })();

    images.forEach((img, imgIndex) => {
      cards.push({
        key: `${index}-${imgIndex}`,
        img,
        // falls back to the first location if a photo has none of its own
        location: locations[imgIndex] || locations[0] || {},
        progress: val.PhysicalProgress,
      });
    });
  });

  const total = cards.length;
  const current = cards[currentSlide] || cards[0];
  const theme = CARD_THEMES[0];
  const goPrev = () => setCurrentSlide((p) => (p - 1 + total) % total);
  const goNext = () => setCurrentSlide((p) => (p + 1) % total);

  const arrowStyle = (side) => ({
    position: "absolute",
    top: "50%",
    [side]: "10px",
    transform: "translateY(-50%)",
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    border: "none",
    backgroundColor: "rgba(255,255,255,0.92)",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    color: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 2,
  });

  const location = current?.location || {};

  return (
    <div
      className="col-12"
      style={{
        backgroundColor: "#fff",
        height: "90vh",
        overflowX: "hidden",
        overflowY: "auto",
        padding: "20px 24px",
        
      }}
    >
      <h6 className="fw-bold mb-4" style={{ fontSize: "13px" }}>
        {t("Uploaded Id")}: {selectedUploadId}
      </h6>

      {total > 0 && (
        <div
          style={{
            maxWidth: "380px",
            margin: "0 auto",
            border: `1.5px solid ${theme.border}`,
            borderRadius: "10px",
            backgroundColor: theme.bg,
            padding: "10px",
          }}
        >
          {/* ---- Photo slider (only this part slides) ---- */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "240px",
              borderRadius: "14px",
              overflow: "hidden",
              backgroundColor: "#eee",
            }}
          >
            <div
              style={{
                display: "flex",
                height: "100%",
                transform: `translateX(-${currentSlide * 100}%)`,
                transition: "transform 0.4s ease",
              }}
            >
              {cards.map((c) => (
                <div
                  key={c.key}
                  style={{ flex: "0 0 100%", height: "100%", cursor: "pointer" }}
                  onClick={() =>
                    setSelectedImage(`${apiurl}/ProgressReport/${c.img}`)
                  }
                >
                  <img
                    src={`${apiurl}/ProgressReport/${c.img}`}
                    alt="Uploaded"
                    loading="lazy"
                    decoding="async"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                    onError={(e) => {
                      console.error("Image not found:", e.target.src);
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              ))}
            </div>

            {total > 1 && (
              <>
                <button type="button" onClick={goPrev} style={arrowStyle("left")} aria-label="Previous">
                  <FaChevronLeft size={14} />
                </button>
                <button type="button" onClick={goNext} style={arrowStyle("right")} aria-label="Next">
                  <FaChevronRight size={14} />
                </button>

                {/* counter badge */}
                <span
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: "rgba(0,0,0,0.55)",
                    color: "#fff",
                    fontSize: "11px",
                    padding: "2px 8px",
                    borderRadius: "10px",
                  }}
                >
                  {currentSlide + 1} / {total}
                </span>
              </>
            )}
          </div>

          {/* dots */}
          {total > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "6px",
                margin: "10px 0 4px",
              }}
            >
              {cards.map((c, i) => (
                <span
                  key={c.key}
                  onClick={() => setCurrentSlide(i)}
                  style={{
                    width: i === currentSlide ? "18px" : "8px",
                    height: "8px",
                    borderRadius: "4px",
                    backgroundColor: i === currentSlide ? theme.border : "#cfd4dc",
                    cursor: "pointer",
                    transition: "all 0.3s",
                  }}
                />
              ))}
            </div>
          )}

          {/* ---- Info (static, does not slide) ---- */}
          <div style={{ marginTop: "12px" }}>
            <InfoRow theme={theme} icon={<TbLocation />} label="Latitude" value={location.latitude || "-"} />
            <InfoRow theme={theme} icon={<FaMapMarkerAlt />} label="Longitude" value={location.longitude || "-"} />
            <InfoRow theme={theme} icon={<FaRegCalendarAlt />} label="Date" value={location.date || "-"} />
            <InfoRow theme={theme} icon={<FaRegClock />} label="Time" value={location.time || "-"} />
            <InfoRow theme={theme} icon={<FaMountain />} label="Elevation" value={`${location.elevation && location.elevation !== "-" ? location.elevation : ""} m`} />
            <InfoRow theme={theme} icon={<FaBullseye />} label="Accuracy" value={`${location.accuracy && location.accuracy !== "-" ? location.accuracy : ""} m`} />
            <InfoRow theme={theme} icon={<FaChartBar />} label="Work Done" value={`${current?.progress || "-"}%`} />
          </div>
        </div>
      )}

      <div className="text-center">
       <button
          type="button"
          //23/10
         style={{ backgroundColor:"white", border:"1px solid blue"}} className="btn fw-bold px-4 my-3"
          onClick={() => setShowSpecific(0)}
        >
          {/* //23/10 */}
          <img src={"/Back-Arrow-32.jpg"}  alt="Back Icon" className="Back-icon" style={{width:"25px", width:"25px",marginRight:"7px"}} />
          {t("Back")}
        </button>
      </div>
    </div>
  );
})()}
      {selectedImage && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.75)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "30px",
          }}
          onClick={() => setSelectedImage(null)}
        >
          {/* Close button */}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "25px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "#000",
              fontSize: "25px",
              fontWeight: "bold",
              cursor: "pointer",
              zIndex: 100000,
            }}
          >
            ×
          </button>

          <img
            src={selectedImage}
            alt="Uploaded Progress Report"
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              display: "block",
              background: "#fff",
              borderRadius: "10px",
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};

export default ProgressReportOutwardList;
